import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from './supabase/supabase-config';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Inicia a verificação de autenticação
    const fetchSession = async () => {
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        setUser(session?.user ?? null);
      } catch (error) {
        console.error('Erro ao buscar a sessão:', error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSession();

    // 2. Assina as mudanças de estado de autenticação
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    // 3. Função de "cleanup" para cancelar a assinatura
    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  // Sair de verdade, mesmo quando a chamada de rede falha.
  //
  // O signOut() padrao usa scope 'global': revoga o refresh token no servidor,
  // o que exige uma requisicao. Se o token ja expirou (a sessao fica dias no
  // localStorage) o servidor responde 403 e o signOut lanca — e ai o botao Sair
  // parecia nao fazer nada, porque o erro subia antes de a sessao local ser
  // limpa.
  //
  // scope 'local' apaga a sessao do dispositivo sem depender do servidor. E o
  // setUser(null) garante que a interface reaja mesmo que ate isso falhe.
  const signOut = async () => {
    try {
      await supabase.auth.signOut({ scope: 'local' });
    } catch (e) {
      console.error('Erro no signOut (seguindo com limpeza local):', e);
    } finally {
      setUser(null);
    }
  };

  // Funções de autenticação
  const value = {
    user,
    loading,
    signInWithGoogle: () =>
      supabase.auth.signInWithOAuth({ provider: 'google' }),
    signUp: (email, password) => supabase.auth.signUp({ email, password }),
    signIn: (email, password) =>
      supabase.auth.signInWithPassword({ email, password }),
    signOut,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
